import { render, staticRenderFns } from "./Receipt-totals.vue?vue&type=template&id=6149230d"
import script from "./Receipt-totals.vue?vue&type=script&lang=js"
export * from "./Receipt-totals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports